type SearchParamsLike = {
    get?: (key: string) => string | null;
} | null | undefined;

const getSubpageFromLocation = (paramsSubpage: string | undefined, searchParams: SearchParamsLike, fallback: string = 'resume'): string => {
    if (paramsSubpage) return paramsSubpage;
    const querySubpage = searchParams?.get?.('subpage');
    return querySubpage || fallback;
};

const buildSubpagePath = (basePath: string, subpage: string): string => `${basePath}/${subpage}`;

export { getSubpageFromLocation, buildSubpagePath };